
import { parsingErrorResponse } from '@/app/infrastructures/misc/Utils';
import { BookingController } from '@/app/ui/controllers/BookingController';
import { MainAppController } from '@/app/ui/controllers/MainAppController';
import { DeleteHydraFileRequest, UploadHydraFileRequest } from '@/data/payload/api/BookingRequest';
import { UploadMultiple } from '@/domain/entities/MainApp';
import { Options, prop, Vue } from 'vue-class-component';

interface PhotoProof {
  source: string;
  desc: string;
  id: number
}

class Props {
  modelValue = prop<string[]>({
    default: () => [],
    type: Array
  });
  maxPhoto = prop<number>({
    default: 5,
    type: Number
  });
}


@Options({
  emits: [
    "update:modelValue",
  ]
})
class PhotoDispute extends Vue.with(Props) {
  image: any = "";
  single = false;
  preview = false;
  proofPhotos: PhotoProof[] = [
    {
      source: "guide-photo-two",
      desc: "",
      id: new Date().getTime() + Math.random()
    }
  ];
  imageUrls: string[] = [];

  async mounted() {
    this.setProofPhotoDescriptions();
    if (this.modelValue.length) {
      this.proofPhotos = this.modelValue.map((p, index) => {
        return {
          source: p,
          desc: index === 0 ? this.primaryPhotoDesc : this.additionalPhotoDesc,
          id: new Date().getTime() + Math.random()
        }
      })
      this.imageUrls = this.modelValue.slice();
    } else {
      this.imageUrls.push("");
      this.modelValue.push("");
      this.$emit("update:modelValue", this.modelValue);
    }
  }

  get imagePreviews() {
    return this.modelValue.map(p => ({
      image: p,
      url: p
    }));
  }

  get primaryPhotoDesc() {
    return this.$t("cargoV2.components.photoDispute.photoType.weighingAndCargo");
  }

  get additionalPhotoDesc() {
    return this.$t("cargoV2.components.photoDispute.photoType.additionalPhoto");
  }

  setProofPhotoDescriptions() {
    this.proofPhotos = this.proofPhotos.map((photo, index) => ({
      ...photo,
      desc: index === 0 ? this.primaryPhotoDesc : this.additionalPhotoDesc
    }));
  }

  onAddImage() {
    this.proofPhotos.push({ source: "", desc: this.additionalPhotoDesc, id: new Date().getTime() + Math.random() });
    this.modelValue.push("");
    this.imageUrls.push("");
    this.$emit("update:modelValue", this.modelValue);
  }

  async onUpload(param: UploadMultiple) {
    if (param.file) {
      try {
        MainAppController.closeMessageModal();
        MainAppController.closeErrorMessage();
        MainAppController.showLoading();
        const resp = await BookingController.uploadHydraFile(
          new UploadHydraFileRequest({
            folderPath: "cargo-dispute/",
            attachFile: param.file
          })
        )
        this.modelValue[param.index] = resp.data;
        this.imageUrls[param.index] = resp.data;
        this.$emit("update:modelValue", this.modelValue);
      } catch (error) {
        MainAppController.showErrorMessage(
          parsingErrorResponse(error, this.$t("cargoV2.components.photoDispute.error.upload"), this.onUpload(param) as any)
        )
      } finally {
        MainAppController.closeLoading();
      }
    };
  }

  onRemove(index: number) {
    // this.deleteFiles(index);
    this.$emit("onDeleteImage", index);
  }

  async deleteFiles(index: number) {
    try {
      MainAppController.closeErrorMessage();
      MainAppController.closeMessageModal();
      MainAppController.showLoading();
      await BookingController.deleteHydraFile(
        new DeleteHydraFileRequest({
          folderPath: "cargo-dispute/",
          attachFiles: [this.imageUrls[index]]
        })
      );
      this.proofPhotos[index] = {
        source: "",
        desc: this.proofPhotos[index].desc || this.additionalPhotoDesc,
        id: this.proofPhotos[index].id
      };
      this.modelValue[index] = "";
      this.imageUrls[index] = "";
      this.$emit("update:modelValue", this.modelValue);
    } catch (error) {
      MainAppController.showErrorMessage(
        parsingErrorResponse(error, this.$t("cargoV2.components.photoDispute.error.delete"), this.deleteFiles(index) as any)
      )
    } finally {
      MainAppController.closeLoading();
    }
  }

  onPreview(index: number) {
    this.image = this.imageUrls[index];
    this.single = false;
    this.preview = true;
  }

  previewPhotoGuide() {
    this.image = require("@/app/ui/assets/images/cargo-dispute-photo-guide.png");
    this.single = true;
    this.preview = true;
  }
}
export default PhotoDispute;
